module.exports = __webpack_public_path__ + "01_short_brown.7ebeaf57.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_short_brown.png
// module id = yQQv
// module chunks = 0